import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'ui-form-card-panel',
  templateUrl: './ui-form-card-panel.component.html',
  styleUrls: ['./ui-form-card-panel.component.scss']
})
export class UiFormCardPanelComponent {
  @Input() label: string = '';
  @Input() buttonLabel: string = '';
  @Input() isEditing: boolean = false;
  @Input() editText: string = 'Edit';
  @Input() hasErrors: boolean;
  @Input() readOnly: boolean = true;
  @Input() canSave: boolean = true;
  @Input() canDelete: boolean = false;
  @Input() colSize: number = 3;

  @Output() editClick = new EventEmitter(); 
  @Output() saveClick = new EventEmitter();
  @Output() cancelClick = new EventEmitter();
  @Output() deleteClick = new EventEmitter();

  editLabel = "Edit";
  deleteLabel = "Delete";

  constructor(private _viewportScroller: ViewportScroller) {

  }

  public getSingleItemClass() {
    return 'col-md-' + (12 / this.colSize);
  }

  ngOnInit() {
    if (this.buttonLabel) {
      this.editLabel = "Edit " + this.buttonLabel;
      this.deleteLabel = "Delete " + this.buttonLabel;
    } else if (this.label) {
      this.editLabel = "Edit " + this.label;
      this.deleteLabel = "Delete " + this.label;
    }

  }

  onEditClick() {
    this.editClick.emit();
    
    setTimeout(() => this._viewportScroller.scrollToAnchor('editForm'));
  }

  onSaveClick() {
    this.saveClick.emit();
  }

  onCancelClick() {
    this.cancelClick.emit();
  }

  onDeleteClick() {
    this.deleteClick.emit();
  }
}
